import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div className="container">
             
             

            
             <p>Durante estos tiempos difíciles, en Israel estamos con vosotros, los españoles, rezando y apoyando, unidos por la esperanza de un mañana más positivo y mejor.</p>
               

             {/*<h1>ALERTAS DE VIAJE A ISRAEL E INFORMACIÓN DE SEGURIDAD</h1>*/}

             <h2 className="ac-pink">ULTIMAS NOTICIAS PARA TURISTAS CON DESTINO A ISRAEL SOBRE EL CORONAVIRUS (COVID-19) :</h2>

            {/* <h2 className="ac-pink">Israel anuncia nuevas medidas de alivio</h2> 


              <p>
              A partir del 1 de junio, el Ministerio de Salud de Israel ha anunciado otra serie de medidas de alivio entre ellas, la apertura de restaurantes, atracciones turísticas y hoteles.
              </p>

              <p>Las playas se abrieron el 20 de mayo.</p>

              <p>A partir del 27 de mayo de 2020, los restaurantes, bares, pubs y clubes pueden abrir, sujetos a algunas restricciones. Las atracciones de ocio y turísticas como hoteles, museos y piscinas también están abiertas, sujetas a algunas restricciones.</p> 

              <p>El Ministerio de Salud también acordó aumentar la capacidad de pasajeros de autobuses y taxis, así como reanudar la actividad de los trenes, a partir del 8 de junio.</p> 

              <p>Las actividades de entretenimiento y ocio se reanudarán el 14 de junio, incluidos los espacios para eventos y jardines, conciertos, teatros, cine, eventos artísticos y culturales, sujetos a algunas restricciones.</p> 

              <p>En el sector turístico, varios países han anunciado abrir sus fronteras a los ciudadanos israelíes: Grecia, Austria, Montenegro, Georgia y ahora Chipre (a partir del 9 de junio).</p>  

              <p>Aerolíneas internacionales como Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International y más han anunciado su intención de reanudar los vuelos comerciales hacia y desde Israel este verano.</p> */}
              
              <h2 className="ac-pink ac-margin-top-1 ac-bigger">Turistas que desean<br className="show-on-mobile"/> viajar a Israel:</h2>

              <p className="ac-align-left-15">
                <strong>En este momento y hasta nuevo aviso,</strong> queda prohibida la entrada a Israel para no-ciudadanos o residentes de Israel que vienen de cualquier parte del mundo. En casos excepcionales, se puede pedir la aprobación del Ministerio de Exteriores demostrando que se puede estar auto-aislado durante 14 días. 
              </p>
           
              <h2 className="ac-pink ac-bigger"> Reglas generales para todos<br className="show-on-mobile"/> los que se encuentren en Israel:</h2>

              <ul>
                <li>
                  Para obtener las últimas noticias de casos de coronavirus en Israel, visite la página del Departamento de Salud. <a href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/" target="_blank">website</a>.
                </li>
                <li>
                  El gobierno israelí está supervisando el brote de cerca y ha implementado medidas temporales como restricciones en las fronteras para viajeros de todo el mundo.
                </li>
                <li>
                  Las personas que muestren síntomas, no pueden acompañar a pacientes o visitar residencias de ancianos.
                </li>
              </ul>

              <h2 className="ac-pink">¡Importante! </h2>

              <ul>
                <li>
                  Si se le ha exigido el auto aislamiento, <strong>, debe informarlo al Ministerio de Salud: </strong> 
                  <a href="https://govforms.gov.il/mw/forms/HouseIsolation%40health.gov.il?displang=en" target="_blank">
                    <strong>www.govforms.gov.il/</strong>
                  </a>
                </li>
              </ul>

              <ul>
                <li>
                  Si tiene 38ºC o más de fiebre, tos, dificultad para respirar, o algún otro síntoma respiratorio, <strong className="ac-pink">hay que auto-aislarse inmediatamente y llamar al 101, línea directa de los Servicios de Emergencia de MDA para indicaciones médicas.</strong>
                </li>
                <li>
                  <strong className="ac-pink">¡Está completamente prohibido entrar en clínicas u hospitales si muestra alguno de los síntomas descritos!</strong>
                </li>
              </ul>

              <h2 className="ac-pink">Preguntas frecuentes sobre Covid19</h2>

              <ol start="1"  className="ac-padding-start">

              </ol>

              <ol start="1" className="ac-padding-start">
                <li>
                  <strong className="ac-pink">Soy un turista en Israel y creo que podría tener el COVID-19, ¿A dónde debo acudir?</strong><br/>
                  Si tienes 38ºC o más de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la línea directa de 101 de Servicios de Urgencia de MDA para indicaciones médicas.
                  <strong className="ac-pink">
                    No acudas a una clínica o sala de urgencias.
                  </strong>
                </li>
                <li>
                  <strong className="ac-pink">¿Cuándo volverá a aceptar Israel a visitantes de fuera</strong><br/>
                  En este momento no hay fecha conocida en la que Israel volverá a permitir la entrada a los visitantes extranjeros.
                </li>
              </ol>

          <Img desktopImg={"infection.jpg"} />

          </div>

          
        <Footer />
      </div>
    )
  }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js